var uhmLogo = require('ui-component-library/assets/logos/uhm.svg');
var uhmLogoWhiteLarge = require('ui-component-library/assets/logos/logo-white.svg');
var aforiLogoBlack = require('ui-component-library/assets/logos/afori/afori_logo_black.svg');
var aforiLogoNeg = require('ui-component-library/assets/logos/afori/afori_logo_neg.svg');
var aforiLogoLight = require('ui-component-library/assets/logos/afori/afori_logo_light.svg');
var aforiAvsandareLogoNeg = require('ui-component-library/assets/logos/afori/afori_avsandare_neg.svg');
export { uhmLogo, uhmLogoWhiteLarge, aforiLogoBlack, aforiLogoNeg, aforiLogoLight, aforiAvsandareLogoNeg, };
